import { render, staticRenderFns } from "./ThePreloader.vue?vue&type=template&id=021f49aa&scoped=true&"
import script from "./ThePreloader.vue?vue&type=script&lang=js&"
export * from "./ThePreloader.vue?vue&type=script&lang=js&"
import style0 from "./ThePreloader.vue?vue&type=style&index=0&id=021f49aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "021f49aa",
  null
  
)

export default component.exports